import { type CreateCreditCardAccountData } from '@webapp/modules/accounts-payable/business-logic/interfaces/ICreditCardAccountRepository'

interface CreditCardAccountPayload {
  name: string
  number: string
  currency: number
  vendor: number
  type: number
  assignees: number[]
  gl_code?: string
}

// POST/PUT /api/v2/ap/creditcards/ payload: `vendor`/`currency` as bare ids,
// `assignees` as a user-id array. `gl_code` is omitted when blank on create;
// the edit contract always sends it (pass includeEmptyGlCode).
export const mapCreditCardAccountFormToPayload = (
  data: CreateCreditCardAccountData,
  { includeEmptyGlCode = false }: { includeEmptyGlCode?: boolean } = {}
): CreditCardAccountPayload => {
  const glCode = data.glCode.trim()

  return {
    name: data.name,
    number: data.number,
    currency: data.currencyId,
    vendor: data.vendorId,
    type: data.type,
    assignees: data.assigneeIds,
    ...(glCode || includeEmptyGlCode ? { gl_code: glCode } : {}),
  }
}
